import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Table, Form } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import { ROUTES } from "../../constants/webRouting";

import Main from "../layout/Main";
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import Badge from "react-bootstrap/Badge";
import { formatDateForView } from "../../utils/helper";

const SpecificationList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchText, setSearchText] = useState("");

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = rows.filter((row) =>
      Object.values(row).some(
        (field) =>
          field && field.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilteredRows(filtered);
  };

  async function init() {
    const result = await solisPowerApi.fetchSpecifications();
    if (result) {
      const mappedRows = result.map((item, index) => ({
        id: item.id || index,
        name: item.name || "-",
        spec_type: item.spec_type || "-",
        section_type: item.section_type || "-",
        status: item.status || "-",
        createddate: item.createddate || "-",
      }));
      setRows(mappedRows);
      setFilteredRows(mappedRows);
    }
  }

  useEffect(() => {
    init();
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "Specification Name",
      flex: 1,
      renderCell: (params) => (
        <Link
          to={ROUTES.SPECIFICATION.CREATE}
          state={params.row}
          style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}
        >
          {params.row.name}
        </Link>
      ),
    },
    {
      field: "spec_type",
      headerName: "Spec Type",
      flex: 1,
    },
    {
      field: "section_type",
      headerName: "Section Type",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Badge bg={params.row.status === "Active" ? "success" : "secondary"}>
          {params.row.status}
        </Badge>
      ),
    },
    {
      field: "createddate",
      headerName: "Created Date",
      flex: 1,
      renderCell: (params) =>
        params.row?.createddate ? formatDateForView(params.row.createddate) : "",
    },
  ];

  return (
    <Main>
      <Container>
        <Row>
          <Col lg={12}>
            <Row className="align-items-end my-2">
              <Col lg={2} md={4} sm={12}>
                <TextField
                  size="small"
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </Col>
              <Col className="d-flex justify-content-end">
                <Button size="sm" className="btn-create" onClick={() => navigate(ROUTES.SPECIFICATION.CREATE)}>
                  New Specification
                </Button>
              </Col>
            </Row>
            <div style={{ height: 400, width: "100%", marginTop: "20px" }}>
              <DataGrid rows={filteredRows} columns={columns} pageSize={25} disableRowSelectionOnClick />
            </div>
          </Col>
        </Row>
      </Container>
    </Main>
  );
};

export default SpecificationList;
